<template>
    <div>Global-component</div>
</template>

<script>
export default {
    name: "global-component",
};
</script>
